/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for a penthouse.
 */
export type AnimaticPenthouseConfig = {};

/** @internal */
export const AnimaticPenthouseConfig$inboundSchema: z.ZodType<
  AnimaticPenthouseConfig,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AnimaticPenthouseConfig$Outbound = {};

/** @internal */
export const AnimaticPenthouseConfig$outboundSchema: z.ZodType<
  AnimaticPenthouseConfig$Outbound,
  z.ZodTypeDef,
  AnimaticPenthouseConfig
> = z.object({});

export function animaticPenthouseConfigToJSON(
  animaticPenthouseConfig: AnimaticPenthouseConfig,
): string {
  return JSON.stringify(
    AnimaticPenthouseConfig$outboundSchema.parse(animaticPenthouseConfig),
  );
}
export function animaticPenthouseConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticPenthouseConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticPenthouseConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticPenthouseConfig' from JSON`,
  );
}
